import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style20({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="originalName"
      activeItemIconName="planet"
      onClick={onClick}
    />
  );
}
